// test422
(422 && 0);
